import React from 'react';

/**
 * Direct Debit Agreement component - This is a static component that displays
 * the Direct Debit Agreement terms. This is separate from the main Direct Debit
 * Request form to avoid cluttering that component.
 * @constructor
 */
const DirectDebitAgreement = () => (
  <ul className="list-disc pl-m text-justify">
    <li className="py-xxs">
      <p className="text-body text-regular">
        I am authorised to sign on behalf of the Business, I am authorised to
        operate the Business&apos;s bank account and I am hereby signing in
        accordance with the account authority on the account;
      </p>
    </li>
    <li className="py-xxs">
      <p className="text-body text-regular">
        I request and authorise Zai Australia Pty Ltd (Zai), User ID’s 342203
        and 481561, as agent for Ordermentum Pty Ltd (ACN 600 457 412) the
        provider of the online ordering platform at www.ordermentum.com (the
        Platform), to arrange a debit to my nominated account to pay for each
        order that my business has submitted via the Platform for goods and
        services, where I have indicated Direct Debit as the preferred payment
        option for that order / related supplier invoice;
      </p>
    </li>
    <li className="py-xxs">
      <p className="text-body text-regular">
        This debit or charge will be arranged by Zai’s financial institution and
        made through the Bulk Electronic Clearing System Framework (BECS) from
        the nominated account and will be subject to the terms and conditions of
        the Direct Debit Request Service Agreement.
      </p>
    </li>
  </ul>
);

export default DirectDebitAgreement;
